import i18n from '@/locales'

export const currencyUnitMap = {
  CNY: {
    sign: '￥',
    cn: i18n.t('currencys.CNY'),
    label: i18n.t('common.currency_cny'),
  },
  USD: {
    sign: '$',
    cn: i18n.t('common.currency_usd'),
    label: i18n.t('common.currency_usd'),
  },
  BRL: {
    sign: 'R$',
    cn: i18n.t('common.currency_brl'),
    label: i18n.t('common.currency_brl'),
  },
  _CNY: {
    sign: '￥',
    cn: i18n.t('currencys.CNY'),
    label: i18n.t('common.currency_cny'),
  },
  _USD: {
    sign: '$',
    cn: i18n.t('common.currency_usd'),
    label: i18n.t('common.currency_usd'),
  },
  _BRL: {
    sign: 'R$',
    cn: i18n.t('common.currency_brl'),
    label: i18n.t('common.currency_brl'),
  },
  '*CNY': {
    sign: '￥',
    cn: i18n.t('currencys.CNY'),
    label: i18n.t('common.currency_cny'),
  },
  '*USD': {
    sign: '$',
    cn: i18n.t('common.currency_usd'),
    label: i18n.t('common.currency_usd'),
  },
  '*BRL': {
    sign: 'R$',
    cn: i18n.t('common.currency_brl'),
    label: i18n.t('common.currency_brl'),
  },
  '*_CNY': {
    sign: '￥',
    cn: i18n.t('currencys.CNY'),
    label: i18n.t('common.currency_cny'),
  },
  '*_USD': {
    sign: '$',
    cn: i18n.t('common.currency_usd'),
    label: i18n.t('common.currency_usd'),
  },
  '*_BRL': {
    sign: 'R$',
    cn: i18n.t('common.currency_brl'),
    label: i18n.t('common.currency_brl'),
  },
}
